import React from "react";
import Home from "../Home/home.js";
import { Switch , Redirect , Route } from "react-router-dom";
import Header from "../Header/header.js";
import Footer from "../Footer/footer.js";
import Contact from "../contact/contact.js";
import About from "../about/about.js";
import Blog from "../blogs/blog.js";

function Main() {
    return (
        <div className="container-fluid">
            <Header />
            <Switch>
                <Route exact path="/" component={()=> <Home />} />
                <Route path="/contact" component={() => <Contact />} />
                <Route path="/achievements" component={() => <About />} />
                <Route path="/blogs" component={() => <Blog />} />
                <Redirect to="/" />
            </Switch>
            <Footer />
        </div>
    );
}

export default Main;